import { useState, useRef } from 'react'
import HogPigLogo from './HogPigLogo'
import './HogTitleGroup.css'

// Each entry: { ch, delay } for a letter, or null for a word space.
// smallFlameLeft: adds a secondary ::after flame at that left position.
const TITLE = [
  { ch: 'H', delay: '0s'     },
  { ch: 'O', delay: '-0.18s' },
  { ch: 'G', delay: '-0.36s', smallFlameLeft: '5%' },
  null,
  { ch: 'O', delay: '-0.54s' },
  { ch: 'F', delay: '-0.12s' },
  null,
  { ch: 'W', delay: '-0.30s', smallFlameLeft: '63%' },
  { ch: 'A', delay: '-0.48s' },
  { ch: 'R', delay: '-0.66s' },
]

const LEAVE_DURATION = 520

export default function HogTitleGroup({ titleClassName }) {
  const [flameState, setFlameState] = useState('')
  const leaveTimer = useRef(null)

  const handleMouseEnter = () => {
    clearTimeout(leaveTimer.current)
    setFlameState('active')
  }

  const handleMouseLeave = () => {
    setFlameState('leaving')
    leaveTimer.current = setTimeout(() => setFlameState(''), LEAVE_DURATION)
  }

  const groupClass = `hog-title-group${flameState ? ` flame-${flameState}` : ''}`

  return (
    <div className={groupClass} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <HogPigLogo className="hog-pig-logo" />
      <h1 className={titleClassName}>
        {TITLE.map((item, i) =>
          item === null
            ? <span key={i}>{' '}</span>
            : <span
                key={i}
                className={`flamed-letter${item.smallFlameLeft ? ' double-flame' : ''}`}
                style={{
                  '--flame-delay': item.delay,
                  ...(item.smallFlameLeft && { '--small-flame-left': item.smallFlameLeft }),
                }}
              >
                {item.ch}
              </span>
        )}
      </h1>
    </div>
  )
}
